"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectAsyncInput = void 0;
var core_1 = require("@blueprintjs/core");
var react_1 = __importStar(require("react"));
var CustomHooks_1 = require("../../../CustomHooks");
var InputField_1 = require("../InputField");
var VSearchSelectFieldAsyncContext_1 = require("./context/VSearchSelectFieldAsyncContext");
exports.VSearchSelectAsyncInput = (0, react_1.forwardRef)(function (_a, ref) {
    var id = _a.id, fill = _a.fill, placeholder = _a.placeholder, suppessLeftIcon = _a.suppessLeftIcon;
    var _b = (0, react_1.useContext)(VSearchSelectFieldAsyncContext_1.VSearchSelectFieldAsyncContext), loading = _b.loading, amountCharacterSearch = _b.amountCharacterSearch, onSearchData = _b.onSearchData, onChangeFirstLoad = _b.onChangeFirstLoad, onClearSearchData = _b.onClearSearchData;
    var _c = (0, react_1.useState)(''), search = _c[0], setSearch = _c[1];
    var tbFunc = (0, CustomHooks_1.useThrottleDebounce)(1000, 500);
    var onChange = function (value) {
        setSearch(value);
        onChangeFirstLoad();
        var filter = function () { return onSearchData({ search: value, firstLoad: false }); };
        value.length >= amountCharacterSearch && tbFunc(filter);
    };
    var onClear = function () {
        setSearch('');
        onClearSearchData();
    };
    return (react_1.default.createElement(InputField_1.VInputField, __assign({}, { fill: fill }, { inputRef: ref, id: "search-select-input-".concat(id), key: "search-select-input-".concat(id), value: search, onChange: onChange }, (!suppessLeftIcon && { leftIcon: 'search' }), { placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Search...', rightElement: loading ? (react_1.default.createElement(core_1.Spinner, { size: core_1.Spinner.SIZE_SMALL })) : (react_1.default.createElement(core_1.Button, { icon: 'filter-remove', onClick: onClear, minimal: true, small: true })) })));
});
